var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Sound",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>icon_library</title>
  <g id="svg-fg">
    <path d="M46.46,32.1a12.62,12.62,0,0,1-8.71,12,.95.95,0,1,1-.67-1.75,10,10,0,0,0,3.19-1.63,10.61,10.61,0,0,0,4.34-8.88,10.85,10.85,0,0,0-7.46-10.09l-.39-.14a.91.91,0,0,1,.43-1.75,2.91,2.91,0,0,1,.63.16,12.63,12.63,0,0,1,8.57,10.6,6.32,6.32,0,0,1,.06.75C46.47,31.62,46.46,31.86,46.46,32.1Z"/>
    <path d="M41.4,29a8,8,0,0,1-3.79,10.49.89.89,0,0,1-1.28-.32.83.83,0,0,1-.11-.4.94.94,0,0,1,.56-.81,6.39,6.39,0,0,0,.55-11.14c-.2-.13-.41-.23-.61-.35a.92.92,0,0,1-.49-.78.88.88,0,0,1,.12-.43.89.89,0,0,1,1.2-.32A8,8,0,0,1,41.4,29Z"/>
    <path d="M33.79,38.73V45a1.14,1.14,0,0,1-.59,1.16,1.17,1.17,0,0,1-1.31-.24c-2.5-1.94-5-3.87-7.5-5.8a1.28,1.28,0,0,0-.71-.23c-2.14,0-4.29,0-6.44,0A1.1,1.1,0,0,1,16,38.6V25.8a1.1,1.1,0,0,1,1.26-1.25c2,0,3.95,0,5.93,0a1.38,1.38,0,0,0,.78-.26q4-3.06,7.92-6.16a1.16,1.16,0,0,1,1.32-.22A1.14,1.14,0,0,1,33.79,19c0,2.2,0,4.4,0,6.6V38.73ZM31.63,43V21.06l-.22.15c-2.09,1.62-4.18,3.24-6.26,4.88a.77.77,0,0,0-.22.53c0,3.59,0,7.19,0,10.78a.67.67,0,0,0,.29.6c1.45,1.11,2.89,2.24,4.34,3.36ZM22.7,37.68v-11H18.16v11Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/sound.svg